import { proxy } from 'valtio';

import { LogActionType, LogEntry, Logger, Mutable } from '../types';

export const logs: Mutable<LogEntry> = proxy([]);

export class ActivityLogger implements Logger {
  private readonly maxLogs: number = 100;

  public constructor(options?: { maxLogs?: number }) {
    if (options?.maxLogs) {
      this.maxLogs = options.maxLogs;
    }
  }

  private getCurrentTimestamp(): string {
    return new Date().toISOString();
  }

  private getSource(): string {
    const error = new Error();
    const stack = error.stack || '';
    const stackLines = stack.split('\n');
    const callerLine = stackLines[3] || ''; // Adjust based on your environment

    return callerLine.trim();
  }

  log<T>(action: LogActionType, data: T): void {
    if (!action) {
      throw new Error('Action type cannot be empty');
    }

    const logEntry: LogEntry<T> = {
      key: this.generateKey(),
      timestamp: this.getCurrentTimestamp(),
      source: this.getSource(),
      action,
      data: this.sanitizeData(data),
    };

    while (logs.length >= this.maxLogs) {
      logs.shift();
    }

    logs.push(logEntry);
  }

  private generateKey(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  private sanitizeData<T>(data: T): T {
    // This can be expanded to handle cases where data might not be JSON serializable
    return JSON.parse(JSON.stringify(data));
  }
}

export const activityLogger = new ActivityLogger();
